module.exports = __webpack_public_path__ + "static/media/moto_5.d540dbf9.png";